import React from 'react';
import { Badge } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { chatColors } from './chatState';

// Точката на чата — по-голяма от стандартната, за да се вижда на таблета; цветът е от chatIndicator: сива — няма
// активен чат или координатор още не го е поел, червена — има непрочетено (с броя им), зелена — поет чат без
// непрочетени.
const ChatBadge = ({ classes, indicator, count, ...props }) => (
  <Badge
    {...props}
    variant={count ? 'standard' : 'dot'}
    badgeContent={count || undefined}
    overlap="rectangular"
    classes={{ badge: `${classes.badge} ${classes[indicator] || classes.none}` }}
  />
);

export default withStyles(theme => ({
  badge: {
    height: 20,
    minWidth: 20,
    borderRadius: 10,
    border: `2px solid ${theme.palette.background.paper}`,
    color: '#fff',
    fontWeight: 'bold',
  },
  none: { backgroundColor: chatColors.none },
  waiting: { backgroundColor: chatColors.waiting },
  unread: { backgroundColor: chatColors.unread },
  seen: { backgroundColor: chatColors.seen },
}))(ChatBadge);
